import api from './api';
import { salvaAcessos } from './auth';

// #133: busca a lista de permissões no servidor. Vive fora de services/auth.js
// porque api.js importa de auth.js — o caminho inverso fecharia um ciclo.
//
// Devolve null quando não deu para confiar na resposta. Nesse caso o chamador
// mantém a cópia que já tinha: gravar uma lista inválida como cache fresco
// fecharia um loop de redirect (rota nega -> / -> /app -> nega -> ...).
export const atualizaAcessos = async () => {
  try {
    const { data } = await api.get('/meus-acessos');
    if (!data || !Array.isArray(data.acessos)) return null;
    salvaAcessos(data.acessos);
    return data.acessos;
  } catch (e) {
    return null;
  }
};

export default atualizaAcessos;
